import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-legend-items',
    styleUrls: ['./legend-items.component.scss'],
    templateUrl: './legend-items.component.html'
})
export class LegendItemsComponent {

    @Input() items: {
        color: string,
        label: string
    }[];

    constructor() {}

}
